enum FileNodeReviewStatus {
    IDLE = 'IDLE',
    MARKED_FOR_REVIEW = 'MARKED_FOR_REVIEW',
    REVIEWED = 'REVIEWED'
  }

  export default FileNodeReviewStatus;
  